import {
	defaultHazardousSubstanceFormState,
	defaultSiteFormState,
	isLocked,
} from "features/forms";

import {
	defaultSaveState,
	saveRequested,
	saveFailed,
	saveSuccess,
} from "utils";

import * as fromTypes from "../actions/types";
import * as R from "ramda";

export const defaultState = {
	...defaultSaveState,
	...defaultSiteFormState,
	...defaultHazardousSubstanceFormState,
	siteId: "NO-ID",
	locked: false,
};

const reducer = (state = defaultState, action) => {
	switch (action.type) {
		case fromTypes.ADD_HAZARDOUS_SUBSTANCE_FORM_RESET:
			return defaultState;
		case fromTypes.ADD_HAZARDOUS_SUBSTANCE_FORM_VALUE_CHANGE:
			return isLocked({
				...state,
				...action.payload,
			});
		case fromTypes.ADD_HAZARDOUS_SUBSTANCE_FORM_SUBMIT:
			return isLocked(saveRequested(state));
		case fromTypes.ADD_HAZARDOUS_SUBSTANCE_FORM_SUBMIT_FAILED:
			return isLocked(saveFailed(state, action.payload));
		case fromTypes.ADD_HAZARDOUS_SUBSTANCE_FORM_SUBMIT_SUCCESS:
			return isLocked(saveSuccess(state));
		case fromTypes.ARCHIVED_HAZARDOUS_SUBSTANCE:
			return archiveHazardousSubstance(R.clone(state), action);
		default:
			return isLocked(state);
	}
};

const archiveHazardousSubstance = (state, action) => {
	state.substances = action.payload;
	state.attachments = R.clone(action.payload.attachments);
	return state;
};

export default reducer;
